export default "__VITE_ASSET__By4Itg$I__"